import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import LoaderModal from '../../../modal/LoaderModal';
import Loader from '../../../Loader';
import { Alert,Row, Col, Card} from 'react-bootstrap';
import {List,ListItem,ListItemText} from '@material-ui/core';
import history from '../../../../history';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class LearningKonten extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            isLoading: false,
            alertShow: false,
            openDialog: false,
            data: props.location.state,
            // idRencbel: props.match.params.idRencbel,
            // idSubBab: props.match.params.idSubBab,
            typeContent: props.match.params.tipe,
            resMessage: '',
            learningSoal: [],
            learningPrime: [],
            isMgtSoal: false,
            selectedProfil: {}
        };
    }

    async componentDidMount() {
        console.clear();
        console.time('LearningKonten time');
        console.info('Props Location State', this.props.location.state);

        this.setState({
            isFetching: true,
            data: {...this.state.data,
                idProfil: null,
                idMapel: null,
                idBab: null,
                idSubBab: null,
                idTematik: null,
                idSubTematik: null,
                idPembTematik: null,
                idMateriPelajaran: null,
                isiMateri: null,
            }
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
            this.getKonten(this.props.match.params.tipe);
        }

        this.setState({
            isFetching: false
        });
        console.timeEnd('LearningKonten time');
    }

    getKonten = async(typeContent) => {
        this.setState({
            isLoading: true
        })

        const res = await accountManagement.post(CONFIG.LEARNING_GET_CONTENT ,
            {...this.props.location.state, typeContent: typeContent})
        .catch(function(error) {
            console.error('getKonten', error)
        })

        if(res) {
            if(res.data.code === "200") {
                this.setState({
                    learningSoal: res.data.data,
                    learningPrime: res.data.dataPrime
                })
            }
            else {
                this.setState({
                    alertShow: true,
                    resMessage: res.data.msg
                })
            }
            this.setState({
                isLoading: false
            });
        }
    }

    addKonten = () => {
        const { typeContent } = this.state;

        if(typeContent === 'SOAL') {
            history.push({
                pathname: '/mgtlearningsoal',
                state: {...this.state.data,
                    ['idProfil']: null,
                    ['judul']: null
                }
            })
        }
        else if(typeContent === 'MATERI') {
            history.push({
                pathname: '/mgtlearningteks',
                state: {...this.state.data,
                    ['idProfil']: null,
                    ['judul']: null
                }
            })
        }
        else if(typeContent === 'VIDEO') {
            history.push({
                pathname: '/mgtlearningvideo',
                state: {...this.state.data,
                    ['idProfil']: null,
                    ['judul']: null
                }
            })
        }
    }

    editKonten = (data) => {
        const { typeContent } = this.state;

        if(typeContent === 'SOAL') {
            history.push({
                pathname: '/mgtlearningsoal',
                state: {...this.state.data,
                    ['idProfil']: data.idProfil,
                    ['judul']: data.judulProfil,
                    ['owner']: data.owner
                }
            })
        }
        else if(typeContent === 'MATERI') {
            history.push({
                pathname: '/mgtlearningteks',
                state: {...this.state.data,
                    ['idProfil']: data.idProfil,
                    ['judul']: data.judulProfil,
                    ['owner']: data.owner
                }
            })
        }
        else if(typeContent === 'VIDEO') {
            history.push({
                pathname: '/mgtlearningvideo',
                state: {...this.state.data,
                    ['idProfil']: data.idProfil,
                    ['judul']: data.judulProfil,
                    ['owner']: data.owner
                }
            })
        }
    }

    viewKonten = (data) => {
        const { typeContent } = this.state;

        if(typeContent === 'SOAL') {
            history.push({
                pathname: '/viewkonten/'+ typeContent +'/' + data.idProfil,
                state: {...this.state.data,
                    ['idProfil']: data.idProfil,
                    ['judul']: data.judulProfil,
                    ['owner']: data.owner
                }
            })
        }
        else if(typeContent === 'MATERI') {
            history.push({
                pathname: '/viewkonten/'+ typeContent +'/' + data.idProfil,
                state: {...this.state.data,
                    ['idProfil']: data.idProfil,
                    ['judul']: data.judulProfil,
                    ['owner']: data.owner
                }
            })
        }
        else if(typeContent === 'VIDEO') {
            history.push({
                pathname: '/viewkonten/'+ typeContent +'/' + data.idProfil,
                state: {...this.state.data,
                    ['idProfil']: data.idProfil,
                    ['judul']: data.judulProfil,
                    ['owner']: data.owner
                }
            })
        }
    }

    handleDelete = (data) => {
        console.clear();
        this.setState({
            openDialog: true,
            selectedProfil: data
        })
    }

    onDelete = async(id) => {
        this.setState({
            isFetching: true,
            openDialog: false
        });

        const res = await accountManagement.delete(CONFIG.LEARNING_DEL_PEMB_LATIHAN + id)
        .catch(function(error) {
            console.error('onDelete', error)
        });

        if (res) {
            if(res.data.code === '200') {
                this.setState({
                    learningSoal: this.state.learningSoal.filter(item => item.idProfil !== id)
                })
            }
            this.setState({
                selectedProfil: {},
                isFetching: false,
                resMessage: res.data.msg,
                alertShow: true
            });
        }
    }

    handleContentSoal = () => {
        console.clear();
        this.setState({
            typeContent: 'SOAL'
        })
        this.getKonten('SOAL');
    }

    handleContentTeks = () => {
        console.clear();
        this.setState({
            typeContent: 'MATERI'
        })
        this.getKonten('MATERI');
    }

    handleContentVideo = () => {
        console.clear();
        this.setState({
            typeContent: 'VIDEO'
        })
        this.getKonten('VIDEO');
    }

    render() {
        console.groupCollapsed('This Render LearningKonten Cek State/Props');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        const { learningPrime, learningSoal, typeContent } = this.state;
        const disabled = 'disabled';
        const btnPrimary = "btn btn-primary btn-sm";
        const btnDark = "btn btn-outline-dark btn-sm";

        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/>
                <Sidebar account={this.props.account}/>
                <div id="content" style={{ paddingBottom: '50px' }}>
                    <Navbar title={'Konten Learning'}/>
                    <div style={{ paddingBottom: '20px' }}>
                        <Row>
                            <Col>
                                <button className={typeContent === 'SOAL' ? btnPrimary : btnDark} style={{ width:'100%' }} onClick={e => this.handleContentSoal()}
                                    disabled={typeContent === 'SOAL' ? disabled : ''}>LEARNING SOAL</button>
                            </Col>
                            <Col>
                                <button className={typeContent === 'MATERI' ? btnPrimary : btnDark} style={{ width:'100%' }} onClick={e => this.handleContentTeks()}
                                    disabled={typeContent === 'MATERI' ? disabled : ''}>LEARNING TEKS</button>
                            </Col>
                            <Col>
                                <button className={typeContent === 'VIDEO' ? btnPrimary : btnDark} style={{ width:'100%' }} onClick={e => this.handleContentVideo()}
                                    disabled={typeContent === 'VIDEO' ? disabled : ''}>LEARNING VIDEO</button>
                            </Col>
                        </Row>
                    </div>

                    <Row>
                        <Col>
                            {this.loadAlert()}
                        </Col>
                        <Col>
                            <button className="btn btn-success pull-right" onClick={this.addKonten}>tambah</button>
                        </Col>
                    </Row>


                    { this.state.isLoading ? <Loader /> :
                        <div style={{paddingBottom: '20px'}}>
                            <List>
                                {/*
                                { learningPrime.map((data, i) =>
                                    <Card style={{ marginBottom: '5px' }} key={i}>
                                        <Row>
                                            <Col sm={6}>
                                            <ListItem>
                                                <span style={{color:'DodgerBlue'}}><i className="fa fa-folder-o" aria-hidden="true"></i></span>
                                                <ListItemText inset primary={data.judulProfil} />
                                            </ListItem>
                                            </Col>

                                            <Col sm={3} style={{margin: 'auto'}}>
                                                <strong>{data.owner}</strong>
                                            </Col>

                                            <Col sm={3} style={{margin: 'auto'}}>
                                                <div className="button-group pull-right">
                                                    <button className="btn btn-info btn-sm" title="simpan... " onClick={() => this.viewKonten(data)}>
                                                        View
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                )}
                                */}

                                { learningSoal.map((data,i) =>
                                    <Card style={{ marginBottom: '5px' }} key={i}>
                                        <Row>
                                            <Col sm={6}>
                                                <ListItem>
                                                    <span style={{ color: 'DodgerBlue' }}><i className="fa fa-folder-o" aria-hidden="true"></i></span>
                                                    <ListItemText inset primary={data.judulProfil} />
                                                </ListItem>
                                            </Col>

                                            <Col sm={3} style={{ margin: 'auto' }}>
                                                <small><strong>created: </strong>{data.createdDate}</small>
                                            </Col>

                                            <Col sm={3} style={{ margin: 'auto' }}>
                                                <div className="button-group pull-right">
                                                    <button className="btn btn-info btn-sm" title="view... " onClick={() => this.viewKonten(data)}>
                                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                                    </button>
                                                    &nbsp;

                                                    <button className="btn btn-warning btn-sm" title="edit..." onClick={(e) => this.editKonten(data)}>
                                                        <i className="fa fa-pencil" aria-hidden="true"></i>
                                                    </button>
                                                    &nbsp;

                                                    <button className="btn btn-danger btn-sm" title="hapus..." onClick={(e) => this.handleDelete(data)}>
                                                        <i className="fa fa-remove" aria-hidden="true"></i>
                                                    </button>
                                                    &nbsp;
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                )}
                            </List>
                        </div>
                    }
                </div>
                {this.confirmDialog()}
            </div>

        );
    }

    loadAlert = () => {
        const {alertShow} = this.state;
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        }
    }

    handleDialog = (data) => {
        this.setState({
            openDialog: true,
            selectedProfil: data
        })
    }

    confirmDialog() {
        const { openDialog, selectedProfil } = this.state;
        const handleClose = () => {
            this.setState({
                openDialog: false,
                data: null
            })
        };
        // console.info(selectedProfil);

        return (
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Perhatian...!!</DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Konfirmasi Hapus <strong>{selectedProfil.judulProfil}</strong> ?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    <button className="btn btn-success" onClick={() => this.onDelete(selectedProfil.idProfil)} autoFocus> Ya </button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(LearningKonten);